<template>
  <div id="main-wrapper" class="login-wrap">
    <div class="container">
      <div class="row justify-content-md-center align-items-center">
        <div class="col-lg-9" id="login-form">
          <div class="card rounded-10">
            <div class="card-header text-center bg-white rounded-10">
              <img src="/images/Tokoin-Logo.svg?=2" width="220" />
            </div>

            <div>
              <div class="form-group text-center">
                <span class="help is-danger">{{ errorMessage }}</span>
              </div>

              <div v-if="ownerForm" class="form-style" data-vv-scope="ownerLoginForm">
                <div class="form-group">
                  <label>{{ $lang.messages.mobile_number }}</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label class="input-group-text">+62</label>
                    </div>
                    <input
                      name="phoneNumber"
                      v-model="ownerLoginParams.phone_number"
                      v-validate="'required|numeric|min:9'"
                      :class="{ 'form-control': true, 'input': true, 'is-danger': errors.has('ownerLoginForm.phoneNumber') }"
                      type="text"
                    />
                  </div>
                  <i v-show="errors.has('ownerLoginForm.phoneNumber')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('ownerLoginForm.phoneNumber')"
                    class="help is-danger"
                  >{{ $lang.messages.please_enter_mobile_number }}</span>

                  <p class="mt-1 font-14">{{ $lang.messages.login_page.send_code_hint }}</p>
                </div>

                <div class="form-group">
                  <!-- <button class="btn btn-primary" @click="confirmOTPModal($event, 'sms')" :disabled="!enableLogin">SEND SMS</button> -->
                  <button class="btn btn-success" @click="confirmOTPModal($event, 'wa')" :disabled="!enableLogin">{{ $lang.messages.login_page.send_whatsapp }}</button>

                  <p class="mt-4 mb-2 font-14 text-center">{{ $lang.messages.login_page.do_you_have_username_password }}</p>
                  <button class="btn btn-outline-primary" @click="toEmployeeForm">{{ $lang.messages.login_page.sigin_to_workspace }}</button>
                </div>
              </div>

              <form v-if="employeeForm" class="form-style" data-vv-scope="employeeLoginForm">
                <div class="form-group">
                  <label for="workspace">Workspace</label>
                  <input
                    name="workspace"
                    v-model="employeeLoginParams.workspace"
                    v-on:keyup.enter="validateBeforeSubmit"
                    v-validate="'required'"
                    :class="{ 'form-control': true, 'input': true, 'is-danger': errors.has('employeeLoginForm.workspace') }"
                    type="text"
                    placeholder="e.g. workspace-tokopos"
                  />
                  <i v-show="errors.has('employeeLoginForm.workspace')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('employeeLoginForm.workspace')"
                    class="help is-danger">{{ $lang.messages.login_page.please_enter_workspace }}</span>
                </div>

                <div class="form-group">
                  <label for="">{{ $lang.messages.username }}</label>
                  <input
                    name="username"
                    v-model="employeeLoginParams.username"
                    v-on:keyup.enter="validateBeforeSubmit"
                    v-validate="'required'"
                    :class="{ 'form-control': true, 'input': true, 'is-danger': errors.has('employeeLoginForm.username') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.username" />
                  <i v-show="errors.has('employeeLoginForm.username')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('employeeLoginForm.username')"
                    class="help is-danger">{{ $lang.messages.login_page.please_enter_username }}</span>
                </div>

                <div class="form-group">
                  <label for="employeePassword">{{ $lang.messages.password }}</label>
                  <div class="input-group" id="show_hide_password">
                    <input
                      name="password"
                      v-on:keyup.enter="validateBeforeSubmit"
                      v-model="employeeLoginParams.password"
                      v-validate="'required'"
                      :class="{'form-control': true,'input': true, 'is-danger': errors.has('employeeLoginForm.password') }"
                      type="password"
                      v-bind:placeholder="$lang.messages.password"/>

                    <div class="input-group-addon border border-left-0 py-1 px-2 border-secondary bg-light">
                      <a href style="vertical-align: sub;">
                        <i class="fa fa-eye-slash" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                  <i v-show="errors.has('employeeLoginForm.password')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('employeeLoginForm.password')"
                    class="help is-danger">{{ $lang.messages.please_enter_password }}</span>
                </div>

                <div class="form-group mt-4">
                  <button class="btn btn-outline-primary" @click="validateBeforeSubmit" :disabled="!enableLogin">{{ $lang.messages.login_page.sigin_to_workspace }}</button>
                </div>


                <p class="mt-4"><button class="btn btn-outline-primary" @click="toOwnerForm">{{ $lang.messages.login_page.sign_in_with_phone_number }}</button></p>
              </form>

              <div v-if="otpForm" class="form-style">
                <p class="mb-0 text-center font-16">{{ $lang.messages.login_page.auth_code_sent }} +62{{ ownerLoginParams.phone_number }}.<br>{{ $lang.messages.login_page.check_auth_code_and_fill }}</p>
                <p class="font-14 mt-4 mb-0 text-center">{{ $lang.messages.login_page.enter_auth_code }}</p>

                <otp-form class="mt-3" :reset="!otpForm" @inputEnable="handleOTPForm($event)" />

                <div class="form-group mt-4">
                  <button class="btn btn-primary" @click="onVerifyOTP" :disabled="!otpFormEnable">{{ $lang.messages.login_page.verify }}</button>
                </div>

                <div class="mt-5 text-center">
                  <vac
                    ref="timer"
                    :left-time="299999"
                    @finish="finishCountdown">
                    <template
                      v-slot:process="{ timeObj }">
                      <p class="mb-0 font-16">{{ `${ $lang.messages.login_page.send_auth_after } ${ timeObj.m }:${ timeObj.s }` }}</p>
                    </template>
                  </vac>

                  <button class="btn btn-link" :disabled="!otpResendEnable" @click="onGetOTP(null, false)">{{ $lang.messages.login_page.resend_new_code }}</button>
                  <br>
                  <button class="btn btn-link" @click="toOwnerForm">{{ $lang.messages.login_page.back_to_login_form }}</button>
                </div>
              </div>
            </div>

            <div v-if="employeeForm || ownerForm" class="text-center mt-5 links">
              <p class="mb-0 font-14">{{ $lang.messages.login_page.dont_have_account_pos }}</p>
              <p class="mb-1 font-14">{{ $lang.messages.login_page.download_pos_from }}</p>

              <p>
                <a href="https://apps.apple.com/app/apple-store/id1489462798" target="_blank">
                  <img
                    src="/images/download-on-appstore.svg"
                    alt="AppStore button"
                    width="170"
                    height="65"
                    class="img-fluid"/>
                </a>

                <a
                  href="https://play.google.com/store/apps/details?id=com.tokoin.pointofsale&hl=en" target="_blank">
                  <img
                    src="/images/google-play-badge.png"
                    alt="AppStore button"
                    width="215"
                    height="65"
                    class="img-fluid"
                  />
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <alert
      ref="confirmSendOTPModal"
      id="confirm-send-otp-modal"
      :title="$lang.messages.login_page.confirm_mobile_number"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      @rightButtonEvent="onGetOTP($event)">
      <p class="mb-0 font-16 text-center">
        {{ $lang.messages.login_page.send_auth_code_via }} +62{{ ownerLoginParams.phone_number }}.
        <br>
        {{ $lang.messages.login_page.check_auth_code }}
      </p>
    </alert>

    <a
      data-toggle="modal"
      data-target="#confirm-send-otp-modal"
      ref="confirmSendOTPModalLinkRef"
      style="display: none"
    />
  </div>
</template>

<script>
import axios from 'axios'
import Alert from '@/components/Alert'
import OtpForm from '@/components/OtpForm'

const OTP_TYPE = {
  WA: 'WA',
  SMS: 'SMS'
}

export default {
  name: 'Login',

  data() {
    return {
      ownerForm: true,
      employeeForm: false,
      otpForm: false,
      otpFormEnable: false,
      otpInput: '',
      otpResendEnable: false,
      otpType: OTP_TYPE.WA,
      ownerLoginParams: {
        phone_number: '',
        country_id: ''
      },
      employeeLoginParams: {
        workspace: '',
        username: '',
        password: '',
      },
      errorMessage: '',
      locale: 'en'
    }
  },

  computed: {
    enableLogin() {
      if (this.ownerForm) {
        return !this.errors.items.length && !!this.ownerLoginParams.phone_number
      } else {
        return !this.errors.items.length &&
          (!!this.employeeLoginParams.workspace &&
            !!this.employeeLoginParams.username &&
            !!this.employeeLoginParams.password)
      }

    }
  },

  components: {
    Alert,
    OtpForm
  },

  methods: {
    resetAllForm() {
      this.ownerForm = false
      this.employeeForm = false
      this.otpForm = false
      this.otpFormEnable = false
      this.otpResendEnable = false
      this.otpInput = ''

      this.errorMessage = ''
      this.$validator.reset()
    },

    toOwnerForm(e) {
      e.preventDefault()
      this.resetAllForm()
      this.ownerForm = true
    },

    toEmployeeForm(e) {
      e.preventDefault()
      this.toggleShowHidePassword()
      this.resetAllForm()
      this.employeeForm = true
    },

    toOtpForm() {
      this.resetAllForm()
      this.otpForm = true
    },

    validateBeforeSubmit(e) {
      e.preventDefault()

      this.$validator.validateAll('employeeLoginForm').then(result => {
        if (result) {
          this.login()
          return
        }
      })
    },

    setLocale() {
      if (!this.locale) {
        this.locale = "en"
      }
      this.$lang.setLang(this.locale)
      localStorage.setItem("locale", this.locale)
    },

    getMe() {
      let cacheVersion = localStorage.getItem('cacheVersion') || '0';
      this.$api
        .getAPI({
          _action: `/me?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}`,
          _body: {
            app_type: 'MENU'
          }
        })
        .then(res => {
          if (!res.is_admin) {
            if (res.country != null && res.country.currency != null) {
              localStorage.setItem('currency', res.country.currency)
            }
            if (res.country != null && res.country.code != null) {
              localStorage.setItem('country_code', res.country.code)
            }
            if (res.country != null && res.country.id != null) {
              localStorage.setItem('country_id', res.country.id)
            }
            if (res.language != null && res.language.code != null) {
              this.locale = res.language.code
              this.setLocale()
            }

            if (res.days) {
              localStorage.setItem('days', res.days)
            }

            localStorage.setItem("d2c_type", res.user.d2c_type);
            localStorage.setItem('user', res.user)
            localStorage.setItem('client_id', res.user.client_id)
            localStorage.setItem(
              'accessright',
              JSON.stringify(res.access_right)
            )
            localStorage.setItem('loggedInUserEmail', res.user.email)
            this.$router.push('/settings')
          } else {
            localStorage.removeItem('access_token')
            localStorage.removeItem('locale')
          }
        }).catch(error => {
          this.errorMessage = error.message
        })
    },

    getGeneralSetting() {
      this.$api
        .getAPI({
          _action: '/backoffice-setting/general'
        })
        .then(res => {
          localStorage.setItem('dining_options', res.dining_options)
          localStorage.setItem('is_enable_b2b', res.is_enable_b2b)
          localStorage.setItem('customer_sharing', res.customer_sharing)
          if (res != null && res.decimal_separator != null) {
            if (res.decimal_separator == 'DOT') {
              localStorage.setItem('decimal_separator', ',')
            } else if (res.decimal_separator == 'COMMA') {
              localStorage.setItem('decimal_separator', '.')
            } else {
              localStorage.setItem('decimal_separator', '')
            }
          }
        })
    },

    onGetCountryList() {
      this.$api
        .getAPI({ _action: '/country/list' })
        .then(res => {
          const countryList = res.list
          const target = countryList.filter(item => item.code === '+62' || item.language_code === 'id')
          if (target.length > 0) {
            this.ownerLoginParams.country_id = target[0].id
          } else {
            this.errorMessage = 'Can not get country'
          }
        })
        .catch(error => {
          this.errorMessage = error
        })
    },

    login() {
      this.errorMessage = ''
      this.$api
        .postAPI({
          _action: '/oauth/token',
          _body: this.employeeLoginParams
        })
        .then(res => {
          localStorage.setItem('cacheVersion', Date.now())
          if (res && res.token) localStorage.setItem('access_token', res.token)
          this.getMe()
        })
        .catch(e => {
          this.errorMessage = this.$lang.messages.login_page.workspace_login_incorrect
          throw e
        })
    },

    async onGetOTP(payload, redirect = true) {
      await this.$recaptchaLoaded()
      const token = await this.$recaptcha('login')
      const that = this
      this.ownerLoginParams.type = this.otpType
      this.ownerLoginParams.recaptchaToken = token
      let formBody = [];
      Object.keys(this.ownerLoginParams).forEach(key => {
        const encodedKey = encodeURIComponent(key)
        const encodedValue = encodeURIComponent(this.ownerLoginParams[key])
        formBody.push(`${encodedKey}=${encodedValue}`)
      })
      formBody = formBody.join('&');

      const urlParams = new URLSearchParams(window.location.search)

      axios({
        url: `${process.env.VUE_APP_API_ENDPOINT}/pos/otp`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'Accept': 'application/json',
          'Accept-Language': urlParams.get('lang') ? urlParams.get('lang') : 'en'
        },
        data: formBody
      }).then(res => {
        if (res.ok || res.status === 200) {
          if (redirect) {
            this.$recaptchaLoaded().then(() => {
              this.$recaptchaInstance.hideBadge()
            })
            // switch to verify otp form
            that.toOtpForm()
          } else {
            that.otpResendEnable = false
            that.$refs.timer && that.$refs.timer.startCountdown(true)
          }
        }
      }).catch(e => {
        this.errorMessage = e.response.data.message
        throw e
      })

      this.$refs.confirmSendOTPModal.close()
    },

    onVerifyOTP(e) {
      this.errorMessage = ''

      e.preventDefault()
      const bodyReq = {
        ...this.ownerLoginParams,
        otp: this.otpInput,
        type: this.otpType
      }
      this.$api
        .postAPI({
          _action: '/pos/verify-otp',
          _body: bodyReq
        })
        .then(res => {
          localStorage.setItem('cacheVersion', Date.now())
          if (res && res.token) localStorage.setItem('access_token', res.token)
          this.getMe()
        })
        .catch(e => {
          this.errorMessage = e.message
          throw e
        })
    },

    handleOTPForm(payload) {
      this.otpFormEnable = payload.enable
      this.otpInput = payload.otp
    },

    confirmOTPModal(e, target = 'wa') {
      e.preventDefault()

      this.$refs.confirmSendOTPModalLinkRef && this.$refs.confirmSendOTPModalLinkRef.click()
      this.otpType = target === 'wa' ? OTP_TYPE.WA : OTP_TYPE.SMS
    },

    finishCountdown() {
      this.otpResendEnable = true
    },

    toggleShowHidePassword() {
      $(document).ready(function() {
        $('#show_hide_password a').on('click', function(event) {
          event.preventDefault()
          if ($('#show_hide_password input').attr('type') == 'text') {
            $('#show_hide_password input').attr('type', 'password')
            $('#show_hide_password i').addClass('fa-eye-slash')
            $('#show_hide_password i').removeClass('fa-eye')
          } else if ($('#show_hide_password input').attr('type') == 'password') {
            $('#show_hide_password input').attr('type', 'text')
            $('#show_hide_password i').removeClass('fa-eye-slash')
            $('#show_hide_password i').addClass('fa-eye')
          }
        })
      })
    }
  },

  mounted() {
    this.toggleShowHidePassword()
    this.$recaptchaLoaded().then(() => {
      this.$recaptchaInstance.showBadge()
    })
  },

  async created() {
    try {
      await this.onGetCountryList()
    } catch(e) {
      throw(e)
    }
  }
}
</script>

<style scoped>
#main-wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

#login-form {
  padding-top: 40px;
  padding-bottom: 40px;
}

.btn:not(.btn-link) {
  display: block;
  width: 100%;
  height: 42px;
  line-height: 42px;
  padding: 0;
  text-transform: uppercase;
  font-weight: 600;
}

.btn:not(.btn-link):disabled {
  background: #dadada;
  border-color: #c4c4c4;
  color: #fff;
  cursor: not-allowed;
}

.btn-link {
  font-size: 16px;
  font-weight: 600;
}

.btn-link:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  color: #412386;
}

.btn:disabled:hover {
  opacity: 1;
}

.btn + .btn {
  margin-top: 16px;
}

.card {
  padding: 64px 48px 40px;
}

/* modal trigger */
.modal {
  background-color: rgba(0, 0, 0, 0.5);
}

@media screen and (max-width: 700px) {
  .card {
    padding: 48px 32px;
  }
}
</style>

<style>
.login-wrap ~ .modal-backdrop {
  display: none !important;
}
</style>
